import { axios } from "@/utils/request";

// 学生状态 scode
export function queryStatu(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/getStuStatuInfo",
    method: "get",
    params: params,
  });
}

// 保存下载状态
export function getCount(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/exam/saveZkzStatus",
    method: "post",
    data: params,
  });
}

// 考生须知 uvCode
export function getNotice(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/get/notice",
    method: "get",
    params: params,
  });
}
export function GradeDetail(params = {}) {
  return axios({
    // url: "/publish/welcome/scoreConfig/getDetail",
    url: "/welcome/publish/scoreConfig/getDetail",
    method: "get",
    params: params,
  });
}
export function getLqList(params = {}) {
  return axios({
    url: "/welcome/publish/recruit/stuColset/queryColSetListPage",
    method: "get",
    params,
  });
}
